import { axios } from '@/services/axios';

const getTemplate = (templateId) => {
    return axios.get(`/AATemplate/${templateId}`);
};

export default getTemplate;
